import { createSlice } from "@reduxjs/toolkit";

export const biometricsSlice = createSlice({
    name: "biometrics",

    initialState: {
        biometricsDetailsList: [],
        errors: {},
    },
    reducers: {
        setLeftbiometrics: (state, action) => {
            console.log("start test", action.payload, "test rea");
            state.leftThumbIso = action.payload.IsoTemplate;
            state.leftAnsiTemplate = action.payload.AnsiTemplate;
            state.leftBitmapData = action.payload.BitmapData;
            state.leftIsoImage = action.payload.IsoImage;
            state.leftRawData = action.payload.RawData;
            state.leftWsqImage = action.payload.WsqImage;
            state.leftQuality = action.payload.Quality;
            state.leftWSQCompressRatio = action.payload.WSQCompressRatio;
            state.leftResolution = action.payload.Resolution;

            state.op = "I";
        },

        setLeftBiometricsImage: (state, action) => {
            state.leftImage = action.payload;
            state.op = "I";
            state.errors.leftBiometrics = {};
        },
        setRightBiometricsImage: (state, action) => {
            state.rightImage = action.payload;
            state.op = "I";
            state.errors.rightBiometrics = {};
        },

        setRightbiometrics: (state, action) => {
            state.rightThumbIso = action.payload.IsoTemplate;
            state.rightAnsiTemplate = action.payload.AnsiTemplate;
            state.rightBitmapData = action.payload.BitmapData;
            state.rightIsoImage = action.payload.IsoImage;
            state.rightRawData = action.payload.RawData;
            state.rightWsqImage = action.payload.WsqImage;
            state.rightQuality = action.payload.Quality;
            state.rightWSQCompressRatio = action.payload.WSQCompressRatio;
            state.rightResolution = action.payload.Resolution;
            state.op = "I";
        },
        clearbiometrics: (state) => {
            state.leftThumbIso = "";
            state.leftAnsiTemplate = "";

            state.rightThumbIso = "";
            state.rightAnsiTemplate = "";
        },

        setBiometricsDetailsData: (state, action) => {
            action.payload && Object.keys(action.payload).forEach(
                (key) => (state[key] = action.payload[key])
            );
            state.op = "N";
            state.sop = "N";
            state.staop = "N";
        },

        setSignature: (state, action) => {
            state.signature = action.payload;
            state.sop = "I";
            state.errors.signature = {};
        },

        setSignatureError: (state, action) => {
            state.errors.signature = {};
            state.errors.signature.message = action.payload.message;
            state.errors.signature.section = action.payload.section;
        },
    },
});

export const {
    setLeftbiometrics,
    setRightbiometrics,
    setBiometricsDetailsData,
    setSignature,
    setSignatureError,
    setLeftBiometricsImage,
    setRightBiometricsImage
} = biometricsSlice.actions;

export default biometricsSlice.reducer;
